/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Spaces_DescInputs */

const en_of_landing_spaces_desc = /** @type {(inputs: Of_Landing_Spaces_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft a layout, choose a template, and decorate desks. Add room links and status objects for an issue, agent, approval, or signed webhook.`)
};

const id_of_landing_spaces_desc = /** @type {(inputs: Of_Landing_Spaces_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun draft denah, pilih template, dan hias meja. Tambahkan tautan ruang serta objek status untuk issue, agen, approval, atau webhook bertanda tangan.`)
};

/**
* | output |
* | --- |
* | "Draft a layout, choose a template, and decorate desks. Add room links and status objects for an issue, agent, approval, or signed webhook." |
*
* @param {Of_Landing_Spaces_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_spaces_desc = /** @type {((inputs?: Of_Landing_Spaces_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Spaces_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_spaces_desc(inputs)
	return en_of_landing_spaces_desc(inputs)
});